const features = [
  {
    icon: 'ri-4k-fill',
    title: '高清画质',
    desc: '支持 1080P 超清播放，画质细腻，每一帧都纤毫毕现，带给你影院级视觉享受。',
  },
  {
    icon: 'ri-speed-up-fill',
    title: '极速加载',
    desc: '全球 CDN 加速节点覆盖，即点即播无需等待缓冲，告别加载圈圈。',
  },
  {
    icon: 'ri-smartphone-fill',
    title: '全端适配',
    desc: '电脑、平板、手机全平台无缝适配，横竖屏自动切换，随时随地畅快观影。',
  },
  {
    icon: 'ri-shield-check-fill',
    title: '免费安全',
    desc: '无需注册、无需付费、无弹窗广告骚扰，纯净观影环境，保护你的隐私安全。',
  },
  {
    icon: 'ri-refresh-fill',
    title: '每日更新',
    desc: '同步全网最新热播剧集，第一时间更新，不错过任何一集精彩内容。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900" style={{ fontFamily: 'var(--font-heading)' }}>
            为什么选择鲁鲁影院
          </h2>
          <p className="mt-2 text-sm text-foreground-500">五大核心优势，打造极致观影体验</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5 md:gap-6">
          {features.map((feat, i) => (
            <div
              key={i}
              className="group p-6 rounded-xl bg-background-100 border border-background-200/60 hover:border-primary-200 transition-all text-center"
            >
              <div className="w-14 h-14 mx-auto mb-4 rounded-2xl bg-primary-100 flex items-center justify-center group-hover:bg-primary-500 transition-colors">
                <i className={`${feat.icon} text-xl text-primary-500 group-hover:text-white transition-colors`}></i>
              </div>
              <h3 className="text-base font-bold text-foreground-900 mb-2" style={{ fontFamily: 'var(--font-heading)' }}>
                {feat.title}
              </h3>
              <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">{feat.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}